import React from 'react'
import ReactDOM from 'react-dom'
import createHistory from 'history/createBrowserHistory'
import { createTracker } from 'redux-segment'
import configureTheme from '../src/configureTheme'
import configureStore from '../src/configureStore'
import App from '../src/App'

const history = createHistory()
const tracker = createTracker()
const store = configureStore(history, tracker)
const theme = configureTheme()

ReactDOM.render(
  <App {...{ store, theme, history }} />,
  document.getElementById('root')
)
